import { Chip } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Colors } from "../../theme/theme";
import { ShowIf } from "../ShowIf";

export const FilePicker = (props: any) => {
  const { disabled, label, onChange, dataTestId, typesAllowed, name, error, onError } = props;
  const [file, setFile] = useState<File>();
  const { t } = useTranslation();

  return (
    <div>
      <label
        id={"file-upload1"}
        htmlFor={"file-upload"}
        style={{
          border: "1px solid #ccc",
          borderRadius: 5,
          color: "#ffff",
          backgroundColor: Colors.primary,
          display: "inline-block",
          padding: "6px 12px",
          cursor: "pointer",
        }}
      >
        {label}
      </label>
      <input
        key={name}
        disabled={disabled}
        id={"file-upload"}
        name={name}
        data-testid={dataTestId}
        style={{ display: "none" }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.files!.item(0)) {
            const reader = new FileReader();
            let file: any;
            reader.readAsText(e.target.files!.item(0) ?? new File([], ""));
            reader.onload = function (event) {
              let error = false
              try {
                const content = reader?.result as string
                file = JSON.parse(content) as any
              } catch( ex ) {
                error = true
              }
              if (error || !typesAllowed.includes(e.target.files!.item(0)!.type) || !file?.features?.length) {
                onError()
              } else {
                setFile(e.target.files!.item(0)!);
                onChange(e.target.files!);
              }
            };
          }
        }}
        type="file"
      />
      {file && <Chip label={file.name} />}
      <ShowIf condition={error}>
        <span style={{ color: "red" }}>{error}</span>
      </ShowIf>
    </div>
  );
};
